"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composeValidators = function () {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    return function (value, allValues, meta) {
        return validators.reduce(function (error, validator) { return error || validator(value, allValues, meta); }, undefined);
    };
};
exports.default = composeValidators;
//# sourceMappingURL=index.js.map